import React, { useEffect, useState } from "react";
import { Collapse, createStyles, IconButton, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useHeaderConfig } from "../../../NavProvider";
import { setCookie, getCookie } from "../../../../../lib/cookie";
import psl from "../../../../../lib/sso/psl";
import Container from "../../../../../components/Container";
import { CloseIcon } from "../../../../icons";
var bcpCookie = "acm_bcp_shown";
var useStyles = makeStyles(createStyles({
    background: {
        backgroundColor: function (props) { return props.backgroundColor || "#d8d8d8"; },
    },
    wrapper: {
        position: "relative",
        display: "flex",
        alignItems: "flex-start",
        padding: "16px 0",
    },
    content: {
        flexGrow: 1,
        margin: "0 24px",
        padding: 0,
        fontSize: "16px",
        lineHeight: "22px",
        color: function (props) { return props.textColor || "#333"; },
        "& a": {
            color: function (props) { return props.linkColor || "#e6007d"; },
            fontWeight: "bold",
            cursor: "pointer",
            "&:hover": {
                textDecoration: "underline",
            },
        },
        "& p": {
            margin: 0,
            padding: 0,
        },
    },
    close: {
        marginTop: -12,
        padding: 12,
        "&:hover": {
            background: "transparent",
        },
    },
}));
var MaintenanceMessage = function (_a) {
    var message = _a.message;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var bcpConfig = useHeaderConfig().bcp;
    var icon = bcpConfig.icon, iconAlt = bcpConfig.iconAlt, closeButtonColor = bcpConfig.closeButtonColor, cookie = bcpConfig.cookie;
    var styles = useStyles(bcpConfig);
    var match = psl(window.location.hostname);
    var domain = match ? "." + match : window.location.hostname;
    var isPortalCookiable = cookie.portalRegexes
        ? cookie.portalRegexes.find(function (portalRegex) { return portalRegex && window.location.href.match(new RegExp(portalRegex, "i")); })
        : true;
    var handleClose = function () { return setOpen(false); };
    var handleExited = function () {
        if (cookie.duration && isPortalCookiable)
            setCookie(bcpCookie, 1, cookie.duration, false, domain);
    };
    useEffect(function () {
        if (message)
            requestAnimationFrame(function () { return setOpen(true); });
    }, [message]);
    if (isPortalCookiable && getCookie(bcpCookie))
        return null;
    return (React.createElement(Collapse, { in: open, timeout: 200, onExited: handleExited },
        React.createElement("div", { className: styles.background },
            React.createElement(Container, null,
                React.createElement("div", { className: styles.wrapper },
                    React.createElement("img", { src: icon, alt: iconAlt, width: "20", height: "20", loading: "lazy" }),
                    React.createElement("p", { className: clsx(styles.content, "maintenance-message-content"), dangerouslySetInnerHTML: { __html: message } }),
                    React.createElement(IconButton, { className: styles.close, edge: "end", onClick: handleClose },
                        React.createElement(CloseIcon, { color: closeButtonColor })))))));
};
export default MaintenanceMessage;
